import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { BrandLockup } from '@/components/BrandMark';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';

const tabs = [
  { to: '/app', label: 'Plan', end: true },
  { to: '/wallet', label: 'Wallet' },
  { to: '/trips', label: 'Trips' },
  { to: '/more', label: 'More' },
];

export function Layout() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const printing = location.pathname.endsWith('/print');
  const guest = user?.mode === 'guest';

  return (
    <div className="mx-auto flex min-h-screen max-w-[430px] flex-col bg-sand print-sheet">
      <div className="no-print h-[3px] bg-navy" />
      <header className="no-print border-b border-line bg-sand px-5 pb-4 pt-5">
        <div className="flex items-center justify-between gap-3">
          <div className="min-w-0 shrink-0">
            <BrandLockup variant="header" />
          </div>
          {user &&
            (guest ? (
              <button
                type="button"
                aria-label="Sign in as household"
                className="inline-flex min-h-[44px] min-w-[44px] shrink-0 items-center justify-center rounded-chip border border-brass/40 bg-brass-tint px-2.5 text-[10px] font-semibold uppercase tracking-wide text-brass"
                onClick={async () => {
                  await api.logout();
                  setUser(null);
                  navigate('/');
                }}
              >
                Guest
              </button>
            ) : (
              <span className="shrink-0 rounded-chip border border-navy bg-navy px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-sand">
                Household
              </span>
            ))}
        </div>
        <h1 className="mt-2 font-display text-[28px] leading-[0.95] text-navy">Airport hold, decided.</h1>
      </header>
      <main className="flex-1 px-4 pb-24 pt-4">
        <Outlet />
      </main>
      {!printing && (
        <nav className="no-print fixed bottom-0 left-1/2 z-10 flex w-full max-w-[430px] -translate-x-1/2 justify-around border-t border-line bg-surface px-2 py-2 shadow-sheet">
          {tabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                `rounded-chip px-3 py-2 text-[11px] font-semibold uppercase tracking-wide ${
                  isActive ? 'bg-navy text-sand' : 'text-muted'
                }`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      )}
    </div>
  );
}
